import { render, staticRenderFns } from "./PageStock.vue?vue&type=template&id=2e64b020&scoped=true&"
import script from "./PageStock.vue?vue&type=script&lang=js&"
export * from "./PageStock.vue?vue&type=script&lang=js&"
import style0 from "./PageStock.vue?vue&type=style&index=0&id=2e64b020&scoped=true&lang=css&"
import style1 from "./PageStock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e64b020",
  null
  
)

export default component.exports